import "./form-employee-bucket.scss";
import { useFormContext } from "react-hook-form";
import { EmployeeBucketFormSchema } from "@core/form/form.rule";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import InputTextareaControl from "@shared/ui/hook-form/input-textarea-control/input-textarea-control";
import { useQyGetTerminationType } from "@core/query/termination-type.query";
import { GetResponseTerminationTypeModel } from "@core/model/query-model-termination-type";
import { useState } from "react";
import { LabelValue } from "@shared/models/label-value.interface";
import DropdownControl from "@shared/ui/hook-form/dropdown-control/dropdown-control";

type InputFormSchema = EmployeeBucketFormSchema;
export function FormEmployeeBucketOffboard() {
  const { control } = useFormContext<EmployeeBucketFormSchema>();
  const [terminationType, setTerminationType] = useState<LabelValue[]>([]);

  const handleGetSuccess = (response: GetResponseTerminationTypeModel) => {
    const responseData = response.data ?? [];
    if (responseData?.length === 0) {
      return;
    }

    const labelValue = LabelValue.MapArray(
      responseData,
      (item) => item.name,
      (item) => item.code
    );
    setTerminationType(labelValue);
  };
  useQyGetTerminationType(
    "",
    9999,
    0,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    true,
    handleGetSuccess
  );

  return (
    <div id="EmployeeBucketOffboard" className="employee-bucket">
      <InputTextareaControl<InputFormSchema>
        control={control}
        name="offboardReason"
        label="Offboard Reason"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter offboard reason"
      />
      <InputDateControl<InputFormSchema>
        control={control}
        name="resignationDate"
        label="Resignation Date"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter resignation date"
      />
      <DropdownControl<InputFormSchema>
        control={control}
        name="terminationType"
        label="Termination type"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter termination type"
        options={terminationType}
      />
      <InputTextareaControl<InputFormSchema>
        control={control}
        name="remarks"
        label="Remarks"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter Remarks"
      />
      <CheckboxControl<InputFormSchema>
        control={control}
        name="hasResignationLetter"
        label="Contains Resignation Letter"
        className=""
        containerClassName="pb-2"
      />
      <CheckboxControl<InputFormSchema>
        control={control}
        name="hasClearance"
        label="Contains Clearance"
        className=""
        containerClassName="pb-2"
      />
      <InputTextareaControl<InputFormSchema>
        control={control}
        name="managementFeedback"
        label="Management feedback"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter Management feedback"
      />
      <InputTextareaControl<InputFormSchema>
        control={control}
        name="memoType"
        label="Memo type"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter Memo type"
      />
    </div>
  );
}

export default FormEmployeeBucketOffboard;
